import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import { useAuth } from '../../context/AuthContext';

const RegistrationValidationDialog: React.FC = () => {
  const { logout } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
      setIsLoggingOut(false);
    }
  };

  return (
    <Dialog 
      open={true} 
      maxWidth="sm" 
      fullWidth
      disableEscapeKeyDown
      onClose={() => {}} // Prevent closing by clicking outside
    >
      <DialogTitle>
        Thank you for registering with ThermalX!
      </DialogTitle>
      <DialogContent>
        <Box sx={{ py: 2 }}>
          <Typography variant="body1" paragraph>
            Your registration has been successfully received and is now being reviewed by our team.
          </Typography>
          <Typography variant="body1" paragraph>
            You will receive a response soon regarding your account status.
          </Typography>
          <Typography variant="body1">
            We appreciate your patience.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={handleLogout} 
          color="primary"
          disabled={isLoggingOut}
          startIcon={isLoggingOut ? <CircularProgress size={20} /> : null}
        >
          {isLoggingOut ? 'Logging out...' : 'Logout'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RegistrationValidationDialog; 